import {
	GET_IOCP_CAPTIVE_PORTALS_LIST,
	GET_IOCP_CAPTIVE_PORTALS_LIST_FAIL,
	GET_IOCP_CAPTIVE_PORTALS_LIST_SUCCESS,
	GET_ROLES_BASED,
	GET_ROLES_BASED_FAIL,
	GET_ROLES_BASED_SUCCESS,
} from '../../constants/globalProfileConstants/roleBasedAccessConstants';

/**
 * Reducer function for managing Role Based Acl list state.
 *
 * This reducer handles actions related to fetching roles data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the role based acl list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const roleBasedListReducer = (state = { roleBasedList: {} }, action) => {
	switch (action.type) {
		case GET_ROLES_BASED:
			return {
				loading: true,
			};
		case GET_ROLES_BASED_SUCCESS:
			return {
				loading: false,
				roleBasedList: action.payload,
			};
		case GET_ROLES_BASED_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const iocpCaptivePortalsReducer = (
	state = { iocpCaptivePortals: {} },
	action
) => {
	switch (action.type) {
		case GET_IOCP_CAPTIVE_PORTALS_LIST:
			return {
				loading: true,
			};

		case GET_IOCP_CAPTIVE_PORTALS_LIST_SUCCESS:
			return {
				loading: false,
				iocpCaptivePortals: action.payload,
			};

		case GET_IOCP_CAPTIVE_PORTALS_LIST_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};
